

























import { DisplaySetting } from "@/store/schemas";
import { Component, Prop, Vue } from "vue-property-decorator";
import FilterSet from "@/api/filter-set";
import { ucfirst } from "@/api/helpers";

@Component({ 
  filters: FilterSet
})
export default class DisplayOptionView extends Vue {
  @Prop({ default: "submission" }) section: string;
  @Prop({ default: "Display options" }) label: string;
  @Prop({ default: () => [] }) settings: DisplaySetting[];
  @Prop({ default: null }) displayOptions: any;
  @Prop({ default: 0 }) refId: string;

  get optionRows() {
    const rows = this.sourceOptionRows();
    const rgbRows = rows.filter(row => row.type === 'rgbset');
    const hasRgbPair = rgbRows.length === 2;
    if (hasRgbPair) {
      const lastPair = rgbRows[1];
      return rows.filter(row => row.key !== lastPair.key).map(row => {
        const firstLabel = row.label;
        const hasOther = row.type === 'rgbset';
        const other = hasOther? lastPair : null;
        const label = hasOther? `Colours` : row.label;
        const isRgbPair = hasOther && row.type === 'rgbset';
        return { ...row, label, other, hasOther, firstLabel, isRgbPair };
      })
    } else {
      return rows;
    }
    
  }

  toLabel(setting: DisplaySetting) {
    if (this.section.includes('media')) {
      return ucfirst(setting.label.replace(/^media(\s*item)?\b/i, '').trim());
    }
    else if (this.section.includes('work')) {
      return ucfirst(setting.label.replace(/^container\b/i, '').trim());
    } else {
      return setting.label;
    }
  }

  sourceOptionRows() {
    return this.hasOptions? Object.entries(this.displayOptions).map(([key, value], oi) => {
      const itemKey = [key, this.section, this.refId, oi].join(',');
      const setting = this.settings.find(s => s.key === key);
      const matched = setting instanceof Object;
      const label = matched ? this.toLabel(setting) : '';
      const classNames = matched ? [setting.type] : [];
      const option = matched && setting.hasOptions ? setting.options.find(op => op.key === value) : null;
      const hasOption = option instanceof Object;
      const type = matched ? setting.type : '';
      return {
        key,
        type,
        matched,
        value,
        option,
        label,
        itemKey,
        classNames,
        hasOption
      }
    }).filter(row => row.matched) : [];
  }

  get hasOptions() {
    return this.displayOptions instanceof Object && Object.keys(this.displayOptions).length > 0;
  }
}
